import { map } from 'lodash/fp';

import { ExcessToggleValues } from '../../selectors/select-excess-toggle-values';

const hospitalExcessToOptions = (hospitalExcess: ExcessToggleValues) =>
  map(
    (value) => ({
      text: `$${value}`,
      value: `${value}`,
    }),
    hospitalExcess,
  );

export default hospitalExcessToOptions;
